import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { RaisedButton, Dialog } from 'material-ui';
import _ from 'lodash';
import { fetchCampaignById } from 'dash-front/campaign/actions/campaigns';
import CampaignInfo from 'dash-front/campaign/components/List/CampaignInfo';
import NotPublishedList from 'dash-front/campaign/containers/Posts/NotPublishedList';
import PublishedList from 'dash-front/campaign/containers/Posts/PublishedList';
import { deleteWithPagination, rejectWithPagination } from 'dash-front/campaign/actions/withPagination';
import { removeFromQuery } from 'dash-front/helpers';
import { getEntities } from 'dash-front/selectors';
import { RejectDialog, DeleteDialog, PublishDialog, LogsDialog } from 'dash-front/campaign/containers/Campaign/dialogs';

class CampaignView extends React.PureComponent {
    componentDidMount() {
        const { campaignId } = this.props.params;
        const { dispatch } = this.props;
        dispatch(fetchCampaignById(campaignId));
    }

    render() {
        const { campaignId } = this.props.params;
        return (
            <div>
                <div>
                    <RaisedButton
                        onTouchTap={browserHistory.push.bind(this, '/campaigns')}
                        primary
                        label={'Back'}
                        style={{ margin: '12px 0' }}
                    />
                </div>
                <CampaignInfo campaignId={campaignId} />

                <h3 className="section-header">Moderation queue</h3>
                <div style={{ marginLeft: -12 }}>
                    <NotPublishedList campaignId={campaignId} />
                </div>
                <h3 className="section-header">Last published posts</h3>
                <div style={{ marginTop: 12 }}>
                    <PublishedList campaignId={campaignId} />
                </div>

                <PublishDialog />
                <LogsDialog />
                <RejectDialog />
                <DeleteDialog />
            </div>
        );
    }
}

export default connect()(CampaignView);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Campaign/CampaignView.js
 **/